/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClmUserInfo } from './ClmUserInfo';
import {
    ClmUserInfoFromJSON,
    ClmUserInfoFromJSONTyped,
    ClmUserInfoToJSON,
    ClmUserInfoToJSONTyped,
} from './ClmUserInfo';
import type { PartnerEmail } from './PartnerEmail';
import {
    PartnerEmailFromJSON,
    PartnerEmailFromJSONTyped,
    PartnerEmailToJSON,
    PartnerEmailToJSONTyped,
} from './PartnerEmail';
import type { PartnerAddress } from './PartnerAddress';
import {
    PartnerAddressFromJSON,
    PartnerAddressFromJSONTyped,
    PartnerAddressToJSON,
    PartnerAddressToJSONTyped,
} from './PartnerAddress';
import type { PartnerName } from './PartnerName';
import {
    PartnerNameFromJSON,
    PartnerNameFromJSONTyped,
    PartnerNameToJSON,
    PartnerNameToJSONTyped,
} from './PartnerName';
import type { PartnerMobile } from './PartnerMobile';
import {
    PartnerMobileFromJSON,
    PartnerMobileFromJSONTyped,
    PartnerMobileToJSON,
    PartnerMobileToJSONTyped,
} from './PartnerMobile';

/**
 * 
 * @export
 * @interface ViPartnerInfo
 */
export interface ViPartnerInfo {
    /**
     * 
     * @type {string}
     * @memberof ViPartnerInfo
     */
    partnerUid?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ViPartnerInfo
     */
    businessRelationshipNumbers?: Array<string>;
    /**
     * 
     * @type {Array<PartnerEmail>}
     * @memberof ViPartnerInfo
     */
    emailAddresses?: Array<PartnerEmail>;
    /**
     * 
     * @type {Array<PartnerMobile>}
     * @memberof ViPartnerInfo
     */
    mobileNumbers?: Array<PartnerMobile>;
    /**
     * 
     * @type {PartnerName}
     * @memberof ViPartnerInfo
     */
    name?: PartnerName;
    /**
     * 
     * @type {PartnerAddress}
     * @memberof ViPartnerInfo
     */
    address?: PartnerAddress;
    /**
     * 
     * @type {Date}
     * @memberof ViPartnerInfo
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ViPartnerInfo
     */
    nationalities?: Array<string>;
    /**
     * 
     * @type {ClmUserInfo}
     * @memberof ViPartnerInfo
     */
    clmUserInfo?: ClmUserInfo;
}

/**
 * Check if a given object implements the ViPartnerInfo interface.
 */
export function instanceOfViPartnerInfo(value: object): value is ViPartnerInfo {
    return true;
}

export function ViPartnerInfoFromJSON(json: any): ViPartnerInfo {
    return ViPartnerInfoFromJSONTyped(json, false);
}

export function ViPartnerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViPartnerInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerUid': json['partnerUid'] == null ? undefined : json['partnerUid'],
        'businessRelationshipNumbers': json['businessRelationshipNumbers'] == null ? undefined : json['businessRelationshipNumbers'],
        'emailAddresses': json['emailAddresses'] == null ? undefined : ((json['emailAddresses'] as Array<any>).map(PartnerEmailFromJSON)),
        'mobileNumbers': json['mobileNumbers'] == null ? undefined : ((json['mobileNumbers'] as Array<any>).map(PartnerMobileFromJSON)),
        'name': json['name'] == null ? undefined : PartnerNameFromJSON(json['name']),
        'address': json['address'] == null ? undefined : PartnerAddressFromJSON(json['address']),
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : (new Date(json['dateOfBirth'])),
        'nationalities': json['nationalities'] == null ? undefined : json['nationalities'],
        'clmUserInfo': json['clmUserInfo'] == null ? undefined : ClmUserInfoFromJSON(json['clmUserInfo']),
    };
}

export function ViPartnerInfoToJSON(json: any): ViPartnerInfo {
    return ViPartnerInfoToJSONTyped(json, false);
}

export function ViPartnerInfoToJSONTyped(value?: ViPartnerInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerUid': value['partnerUid'],
        'businessRelationshipNumbers': value['businessRelationshipNumbers'],
        'emailAddresses': value['emailAddresses'] == null ? undefined : ((value['emailAddresses'] as Array<any>).map(PartnerEmailToJSON)),
        'mobileNumbers': value['mobileNumbers'] == null ? undefined : ((value['mobileNumbers'] as Array<any>).map(PartnerMobileToJSON)),
        'name': PartnerNameToJSON(value['name']),
        'address': PartnerAddressToJSON(value['address']),
        'dateOfBirth': value['dateOfBirth'] == null ? value['dateOfBirth'] : value['dateOfBirth'].toISOString(),
        'nationalities': value['nationalities'],
        'clmUserInfo': ClmUserInfoToJSON(value['clmUserInfo']),
    };
}

